<template>
  <div class="vld-parent" id="app">
    <loader :isLoading="loading"/>
    <router-view/>
  </div>
</template>

<script>
import loader from '@/components/shared/Loader'
import { mapState } from 'vuex'

export default {
  components: {
    loader
  },
  computed: mapState({
    loading: state => state.loading.is
  })
}
</script>

<style lang="scss">

</style>
